// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__2AK5s","addWidgetButton":"Header_addWidgetButton__2zhA0","dashboardTabs":"Header_dashboardTabs__rFwDH","active":"Header_active__9Oh14"};